import { useConfigs } from '../contexts/ConfigsContext';

// Mantido por compatibilidade: STORAGE_KEY e EVENT_NAME ainda sao
// importados por telas que disparam reload manual (ConfiguracaoVendas).
const STORAGE_KEY = 'configVendas';
const EVENT_NAME = 'configVendasChanged';

const useConfigVendas = () => {
  const { configs, loaded, refresh } = useConfigs();
  const v = configs.vendas;
  return {
    contratoAtivo: !!v.contrato,
    ordemServicoAtivo: !!v.ordem_servico,
    pdvAtivo: !!v.pdv,
    vendaRapidaAtivo: !!v.venda_rapida,
    mostrarSkuPedido: !!v.mostrar_sku_pedido,
    // Combo de cliente no Novo Pedido de Venda:
    // 0 = "Fantasia - Razao Social" (padrao), 1 = so Fantasia, 2 = so Razao Social
    exibicaoClientePedido: Number(v.exibicao_cliente_pedido) || 0,
    // 0 = padrao, 1 = classico Ribeiro, 2 = classico Alquilabor
    layoutPedido: Number(v.layout_pedido) || 0,
    // Perfil da OS (quais abas a OS mostra): 0 = servicos gerais,
    // 1 = oficina e veiculos, 2 = instalacao veicular (oficina + bloqueador/troca).
    perfilOS: Number(v.perfil_os) || 0,
    // Fechamento do PDV: 0 nao lanca, 1 por meio de pagamento, 2 total unico.
    // `?? 1` e nao `|| 1` de proposito: 0 e escolha valida (nao lancar).
    pdvFechamentoFinanceiro: Number(v.pdv_fechamento_financeiro ?? 1),
    pdvCreditoAReceber: Number(v.pdv_credito_a_receber ?? 1),
    // Texto padrao que o Pedido de Venda usa ao abrir uma proposta NOVA.
    propostaGarantia: v.proposta_garantia || '',
    propostaValidade: v.proposta_validade || '',
    vendasConfigAtivo: !!(v.contrato || v.ordem_servico || v.pdv),
    raw: v,
    loaded,
    reload: refresh,
  };
};

export { STORAGE_KEY, EVENT_NAME };
export default useConfigVendas;
